<template>
  <!-- Adjust Size -->
  <div class="row">
    <div class="col-md-12">
      <div class="grid">
        <div class="grid-title">
          <h4>Adjust Sizes</h4>
        </div>
        <div class="grid-body">
          <div class="row">
            <div class="col-sm-2">
              <label>Chest</label>
              <input type="text" v-model="size.chest" class="form-control" />
            </div>
            <div class="col-sm-2">
              <label>Chest Width</label>
              <input
                v-model="size.chest_width"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Lower Chest</label>
              <input
                v-model="size.lower_chest"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Chest Distance</label>
              <input
                v-model="size.chest_distance"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Chest Depth</label>
              <input
                v-model="size.chest_depth"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Back Width</label>
              <input
                v-model="size.back_width"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Waist</label>
              <input v-model="size.waist" type="text" class="form-control" />
            </div>
            <div class="col-sm-2">
              <label>Hip</label>
              <input v-model="size.hip" type="text" class="form-control" />
            </div>
            <div class="col-sm-2">
              <label>Wrist</label>
              <input v-model="size.wrist" type="text" class="form-control" />
            </div>
            <div class="col-sm-2">
              <label>Shoulder</label>
              <input v-model="size.shoulder" type="text" class="form-control" />
            </div>
            <div class="col-sm-2">
              <label>Arm Length</label>
              <input
                v-model="size.arm_length"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Collar</label>
              <input v-model="size.collar" type="text" class="form-control" />
            </div>
            <div v-if="!isDress" class="col-sm-2">
              <label>Shirt Length</label>
              <input
                v-model="size.shirt_length"
                type="text"
                class="form-control"
              />
            </div>
            <div v-if="isDress" class="col-sm-2">
              <label>Dress Length</label>
              <input
                v-model="size.dress_length"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Arm Hole</label>
              <input v-model="size.arm_hole" type="text" class="form-control" />
            </div>
            <div class="col-sm-2">
              <label>Short Arm</label>
              <select v-model="size.short_arm" class="from-control select">
                <option value="yes">Yes</option>
                <option value="no">No</option>
                <option value="34">3/4 length</option>
              </select>
            </div>

            <div class="col-sm-2">
              <label>Back Width Top</label>
              <input
                v-model="size.back_width_top"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Chest neck Chest</label>
              <input
                v-model="size.chest_neck_chest"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Neck Waist</label>
              <input
                v-model="size.neck_waist"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Waist Neck Waist</label>
              <input
                v-model="size.waist_neck_waist"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Waist Bottom</label>
              <input
                v-model="size.waist_bottom"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Waist Distance Waist</label>
              <input
                v-model="size.waist_distance_waist"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Waist Distance Hip</label>
              <input
                v-model="size.waist_distance_hip"
                type="text"
                class="form-control"
              />
            </div>
            <div class="col-sm-2">
              <label>Wrist 34</label>
              <input v-model="size.wrist_34" type="text" class="form-control" />
            </div>
            <div class="col-sm-2">
              <label>Body Height</label>
              <input
                v-model="size.body_height"
                type="text"
                class="form-control"
              />
            </div>

            <div class="col-sm-2">
              <label>Cut</label>
              <select v-model="size.cut" class="from-control select">
                <option value="regular">Regular</option>
                <option value="fitted">Fitted</option>
              </select>
            </div>
            <div class="col-sm-4">
              <label>Upper Arm</label>
              <input
                v-model="size.upper_arm"
                type="text"
                class="form-control"
              />
              Upper Arm Calculation System Only -
              {{ round(size.upper_arm_calc_system_only) }}<br />
              Upper Arm Calculation - {{ round(size.upper_arm_calc) }} ( -7 Body
              Size )
            </div>
            <div class="col-md-12">
              <br />
              <button
                class="btn btn-block btn-success"
                @click="updateSizes()"
                v-if="!isReadOnlyUser"
              >
                UPDATE
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Swal from "sweetalert2";
export default {
  props: {
    isDress: {
      type: Boolean,
      default: false,
    },
    isReadOnlyUser: {
      type: Boolean,
      default: false,
    },
    size: {
      type: Object,
      default: {},
    },
    orderNumber: [Number, String],
  },
  methods: {
    async updateSizes() {
      try {
        let res = await axios.put("shirt_orders/update/size", {
          size: this.size,
          api_call: true,
        });
        if (res) {
          Swal.fire("Success", "Successfully Updated", "success");
        }
      } catch (error) {
        if (error.response.status === 403) {
          toastr.error(
            "Not authorized, please ensure that you have the required permissions."
          );
        } else {
          toastr.error(
            "There was some errors, please correct and try again, or contact the admins"
          );
        }
      }
    },
    round(t) {
      return round(t, 2);
    },
  },
};
</script>

<style scoped>
.form-control {
  margin-bottom: 10px;
  height: 42px !important;
  border-radius: 4px !important;
}
.select {
  width: 100% !important;
  height: 42px !important;
  border-radius: 4px !important;
}
h4 {
  font-weight: bold !important;
}
.grid-title {
  border-top: 1px solid #eee;
}
</style>
